export default "__VITE_ASSET__C$LsPCI8__"